/**
 * GL Code Types
 * Types for the GL chart of accounts and per-line GL code suggestions.
 * Mirrors AutoLedger.Library/DTOs/GlCode.
 */

/** A single GL code from the client's chart of accounts */
export interface GlCodeDto {
    id: number;
    code: string;
    description?: string | null;
}

/** One ranked GL code candidate for a line item */
export interface GlSuggestionDto {
    code: string;
    description?: string | null;
    /** Model-reported confidence in [0, 1] */
    confidence: number;
    /** 1-based rank within the line (1 = top suggestion) */
    rank: number;
}

/** Ranked suggestions for one line item (best-first, at most 5) */
export interface GlLineSuggestionsDto {
    lineItemId: number;
    suggestions: GlSuggestionDto[];
}

/** Response of POST /api/documents/{id}/gl-suggestions */
export interface GlSuggestionsResponseDto {
    documentId: number;
    /** "cached" | "generated" | "noGlCodes" | "noLineItems" */
    status: string;
    lines: GlLineSuggestionsDto[];
}

/** One feedback line: what the user saved for a line that had suggestions */
export interface GlSuggestionFeedbackLineDto {
    lineItemId: number;
    /** The GL code the user saved (null = cleared the field) */
    chosenCode: string | null;
}

/** Request of POST /api/documents/{id}/gl-suggestions/feedback */
export interface GlSuggestionFeedbackRequestDto {
    lines: GlSuggestionFeedbackLineDto[];
}

/**
 * Line-item custom field code the suggestion UI binds to, by convention —
 * the GL counterpart of the existing "routing_code" convention.
 */
export const GL_CODE_FIELD_CODE = "gl_code";
